import { render, staticRenderFns } from "./AppProgramaPresentacion.vue?vue&type=template&id=69871164&scoped=true&"
import script from "./AppProgramaPresentacion.vue?vue&type=script&lang=ts&"
export * from "./AppProgramaPresentacion.vue?vue&type=script&lang=ts&"
import style0 from "./AppProgramaPresentacion.vue?vue&type=style&index=0&id=69871164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69871164",
  null
  
)

export default component.exports